import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Chip from "@mui/material/Chip";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import styles from "./ConsentDetails.module.scss";
import CircularProgress from "@mui/material/CircularProgress";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useParams } from "react-router-dom";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PlaylistModal from "./VideoManager/ConcentBundelAddNewPlaylist";
import SelectFromStockVideoModal from "./VideoManager/SelectFromStockVideoModal";
import { VideoItem } from "./VideoManager/types";
// ConsentDetails.tsx
import ClausesEditorPage from './ConsentDetails/ClausesOrderPage';
import ModeSwitchWithFeedback from "./ModeSwitchWithFeedback";
import { Grid, Stack, Card, CardHeader, CardContent, Divider } from "@mui/material";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import { Avatar } from "@mui/material";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { Button } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import cx from "classnames";
import { toast } from "react-toastify";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import $ from "jquery";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import ConsentBundelPlaylistModel from "./VideoManager/ConsentBundelPlaylistModel";
import { motion, AnimatePresence } from "framer-motion";
import {
  EditorState,
  ContentState,
  convertFromHTML,
  convertToRaw,
} from "draft-js";
import htmlToDraft from "html-to-draftjs";
import draftToHtml from "draftjs-to-html";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { findIndex } from "lodash";
import PdfViewer from "./PdfViewer";
import LoadingButton from "@mui/lab/LoadingButton";
import FormModal from "./Fp17Form/DentalTreatmentModal";
import ReactPlayer from "react-player";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  SvgIcon,
} from "@mui/material";

import { useRef } from "react";
import ImageGalleryV2 from "./ImageGallery/imageGalleryV2";
import { confirmAlert } from "react-confirm-alert";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import CloseIcon from "@mui/icons-material/Close";
import SignatureModal from "./Signature/SignatureModal";
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {Tooltip } from '@mui/material';
import Checkbox from "@mui/material/Checkbox";
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Switch } from "@mui/material";
import { CheckBoxOutlineBlank, CheckBox } from "@mui/icons-material";

const steps = [
  "Consent Details",
  "Treatment Identified",
  "Consent form",
  "Videos",
];

const customStyleMap = {
  "rdw-center-aligned-block": {
    textAlign: "center",
  },
};

export default function ConsentDetails() {
  const queryClient = useQueryClient();
  let navigate = useNavigate();
  let { consentBundleId } = useParams();
  const [treatmentOptions, setTreatmentOptions] = React.useState<any[]>([]);
  const [selectedPlans, setSelectedPlans] = React.useState<any[]>([]);
  const [value, setValue] = React.useState(1);
  const [activeStep, setActiveStep] = React.useState(0);
  const [editorState, setEditorState] = React.useState<any>(
    EditorState.createEmpty()
  );
  const [data, setData] = React.useState<any>(null);
  const [pdfUrl, setPdfUrl] = React.useState("");
  const [isOpenPdfViewer, setIsOpenPdfViewer] = React.useState(false);
  const [isLoadingViewPdf, setIsLoadingViewPdf] = React.useState(false);
  const [isUpdatingPrice, setIsUpdatingPrice] = React.useState(false);
  const [isRequirefp17dc, setIsRequirefp17dc] = React.useState(false);
  const [pageLoaded, setPageLoaded] = React.useState(false);

  const [practitionerList, setPractitionerList] = useState([]);
  const [isLoadingPractitioners, setIsLoadingPractitioners] = useState(true);
  const [selectedPractitioner, setSelectedPractitioner] = useState(null);
  const user = queryClient.getQueryData(["user"]);
  const [showAddButton, setShowAddButton] = useState(false);
  const [fp17dcIsChecked, setFp17dcIsChecked] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [clinicianId, setClinicianId] = useState("");

  //video
  const [selectedVideo, setSelectedVideo] = React.useState<any>(null);
  const [currentVideoIndex, setCurrentVideoIndex] = React.useState(0);
  const videoRef = useRef(null);
  const editorRef = useRef(null);
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const [content, setContent] = useState("");
  const [instances, setInstances] = useState([]);
  const editorInstanceRef = useRef(null);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [refreshed, setRefreshed] = useState(false);
  const [showGallery, setShowGallery] = useState(false);
  const [isChecked, setChecked] = useState(false);
  const [applyMySignature, setApplyMySignature] = useState(false);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [openConsentModal, setOpenConsentModal] = useState(false);
  const [selectedListId, setSelectedListId] = useState<number | null>(null);
  const [selectedConsentBundleId, setSelectedConsentBundleId] = useState<number | null>(null);
  const [isPlaylistModalOpen, setIsPlaylistModalOpen] = useState(false);
  const [applyConsentTemplates, setApplyConsentTemplates] = useState(true);
  const [loadClinicianTemplates, setLoadClinicianTemplates] = useState(false);
  const [selectedPlanDetails, setSelectedPlanDetails] = useState([]);
  const [availableConsentClauses, setAvailableConsentClauses] = React.useState([]);
  const [isPanelOpen, setIsPanelOpen] = React.useState(false);
  const [checkedClauses, setCheckedClauses] = React.useState(new Set());
  const [previewClauseId, setPreviewClauseId] = React.useState(null);
  const [previewClause, setPreviewClause] = useState(null);
  const [availableTemplateIds, setAvailableTemplateIds] = React.useState([]);
  const [selectedClauseIds, setSelectedClauseIds] = React.useState(new Set());
  const [refreshEditorCounter, setRefreshEditorCounter] = useState(0);
  const [showSavedFlash, setShowSavedFlash] = useState(false);
  const [openModalPlaylist, setOpenModalPlaylist] = useState(false);
  const [s3Videos, setS3Videos] = useState<VideoItem[]>([]);
  const [selectedVideos, setSelectedVideos] = useState<string[]>([]);
  const [hoveredVideo, setHoveredVideo] = useState<string | null>(null);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [playlist, setPlaylist] = useState<any[]>([]);  
  const [isConsentModalsaved, setisConsentModalsaved] = useState(false);
  const icon = <CheckBoxOutlineBlank fontSize="small" />;
  const checkedIcon = <CheckBox fontSize="small" />;
 const [openTreatmentPopup, setOpenTreatmentPopup] = useState(false);
 const [isConsentEnabled, setIsConsentEnabled] = useState(false);
 const [isConsentEditorMode, setIsConsentEditorMode] = useState(false);


  const openPopup = () => setOpenTreatmentPopup(true);
  const closePopup = () => setOpenTreatmentPopup(false);

  const confirmRefresh = () => {
    refreshTreatments.mutate();
    closePopup();
  };

  function TreatmentIcon(props) {
  return (
    <SvgIcon {...props} color="warning" fontSize="large">
      <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
    </SvgIcon>
  );
}



  useEffect(() => {
    // Load the CKEditor script dynamically
    const script = document.createElement("script");
    script.src = "/ckeditor/ckeditor.js";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      console.log("CKEditor script loaded.");
      setIsScriptLoaded(true);
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
  const initializeEditor = () => {
    if (isConsentEditorMode) return; // safety: never init while clause editor is active
    if (editorRef.current && window.CKEDITOR) {
      const editorInstance = window.CKEDITOR.replace(editorRef.current, {
        height: 570,
      });

      if (editorInstance) {
        editorInstance.on("instanceReady", () => {
          console.log("CKEditor instance ready.");
          editorInstance.setData(content);

          editorInstance.on("change", () => {
            const updatedContent = editorInstance.getData();
            setContent(updatedContent);
          });
        });

        editorInstanceRef.current = editorInstance;
      } else {
        console.error("Failed to initialize CKEditor.");
      }
    }
  };

  const destroyAllEditors = () => {
    if (!window.CKEDITOR || !window.CKEDITOR.instances) return;
    const instances = window.CKEDITOR.instances;
    const keys = Object.keys(instances);
    if (keys.length > 0) {
      console.log("Destroying existing CKEditor instance(s)...");
      keys.forEach((key) => {
        instances[key].destroy(true);
        console.log(`${key} instance destroyed.`);
      });
    }
  };

  // If clause editor mode is ON, make sure CKEditor is fully torn down and exit early
  if (isConsentEditorMode) {
    destroyAllEditors();
    return;
  }

  // Other flows you already had
  if (activeStep === 1 || activeStep === 3 || refreshed) {
    destroyAllEditors();
  }

  if (isScriptLoaded && isDataLoaded && activeStep === 2) {
    initializeEditor();
  }

  // Cleanup on unmount or deps change
  return () => {
    destroyAllEditors();
  };
}, [
  isConsentEditorMode, // <-- add this
  isScriptLoaded,
  isDataLoaded,
  activeStep,
  refreshed,
  // (optional) remove `content` to avoid unnecessary re-inits
]);

  const treatmentDetails = useQuery(
    ["treatmentDetails"],
    async () => {
      const { data } = await axios.get(`/consent_bundle/${consentBundleId}`);
      console.log("Treatment Details:", data);
      setLoadClinicianTemplates( data.load_clinician_templates);
      setAvailableTemplateIds(data.consent_form.consent_form_template_ids);
     
      setApplyMySignature(Object.keys(data.clinician_signature).length > 0);
      setIsRequirefp17dc(data.require_fp17dc);
      setClinicianId(data.clinician_table_id);
      return data;
    },
    {
      onSuccess: async (data) => {
        setData(data);
        if (data.status !== "Draft") {
          navigate(`/${data.id}/summary`);
        }

        const { data: practitionerData } = await axios.get(
          `/consent_bundle/${data.id}/get_practitioner_list_for_consent_bundle`
        );
        setPractitionerList(practitionerData);
        console.log("Practitioner List:", data);
        if (data?.clinician_id && practitionerData?.length > 0) {
          const matchedPractitioner = practitionerData.find(
            (practitioner) => practitioner.dentally_id === data.clinician_id
          );
          if (matchedPractitioner) {
            setSelectedPractitioner(matchedPractitioner.id);
          }
        }

        const txt = data?.consent_form?.body || "";
        setContent(txt);
        setIsDataLoaded(true);

        const plans = data.treatment_plan.treatments.map((plan) => ({
          ...plan,
          label: plan.description,
        }));

        setSelectedPlans(plans);
        console.log("Selected Plans:", plans);

        queryClient.invalidateQueries({ queryKey: ["treatmentPlans"] });
      },

      enabled: !!consentBundleId,
      refetchOnWindowFocus: false,
      staleTime: 480000,
    }
  );

  const treatmentPlans = useQuery(
    ["treatmentPlans"],
    async () => {
      const { data } = await axios.get(
        `/treatment?practice_id=${treatmentDetails.data.practice_id}`
      );
      return data;
    },
    {
      onSuccess: (data) => {
        const plans = data.treatments.map((plan) => ({
          ...plan,
          label: plan.description,
        }));
        setTreatmentOptions(plans);
      },
      enabled: !!treatmentDetails?.data?.practice_id,
      refetchOnWindowFocus: false,
      staleTime: 480000,
    }
  );

  const handleSelectedPlanDetails = () => {
    console.log("Selected Plans:", selectedPlans);
    console.log("Treatment Options:", treatmentOptions);
    const selectedPlanDetails = selectedPlans
      .map((selected) => treatmentOptions.find((plan) => plan.id === selected.treatment_id))
      .filter(Boolean); 
    setSelectedPlanDetails(selectedPlanDetails);
    console.log("full selected plan details:", selectedPlanDetails);
  };

  const previewPdf = async () => {
    const consentForm = editorInstanceRef.current.getData();
    setIsLoadingViewPdf(true);

    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(consentForm, "text/html");
      const imgTags = Array.from(doc.querySelectorAll("img"));
      let updatedConsentForm = doc.body.innerHTML;

      for (const img of imgTags) {
        const src = img.src;
        const imgAlt = img.alt || "";
        const imgHeight = img.getAttribute("height");
        const imgWidth = img.getAttribute("width");

        if (
          !img.style ||
          !img.style.cssText.includes("height") ||
          !img.style.cssText.includes("width")
        ) {
          const imgStyle = `height: ${imgHeight || "auto"}px; width: ${
            imgWidth || "auto"
          }px;`;
          const correctedImgTag = `<img src="${src}" alt="${imgAlt}" style="${imgStyle}" />`;
          updatedConsentForm = updatedConsentForm.replace(
            img.outerHTML,
            correctedImgTag
          );
        }

        if (src.startsWith("data:image")) {
          const mimeTypeMatch = src.match(/data:(image\/[a-zA-Z]+);base64,/);
          if (mimeTypeMatch) {
            const mimeType = mimeTypeMatch[1];
            const base64Data = src.replace(/data:image\/[a-zA-Z]+;base64,/, "");
            const byteString = atob(base64Data);
            const arrayBuffer = new Uint8Array(byteString.length);

            for (let i = 0; i < byteString.length; i++) {
              arrayBuffer[i] = byteString.charCodeAt(i);
            }

            const file = new File([arrayBuffer], "image.png", {
              type: mimeType,
            });

            const response = await uploadCallback(file);
            const newImgTag = `<img src="${response.data.link}" alt="${imgAlt}" style="height: 300px; width: 300px;" />`;
            updatedConsentForm = updatedConsentForm.replace(
              img.outerHTML,
              newImgTag
            );
          }
        }
      }

      editorInstanceRef.current.setData(updatedConsentForm);

      const response = await axios({
        url: `${process.env.REACT_APP_BASE_URL}consent_bundle/${consentBundleId}/generate_preview_pdf`,
        method: "POST",
        responseType: "blob",
        data: { consentForm: updatedConsentForm },
      });

      const href = URL.createObjectURL(response.data);
      setPdfUrl(href);
      setIsOpenPdfViewer(true);
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      setIsLoadingViewPdf(false);
    }
  };

  const uploadCallback = (file) => {
    //console.log(file);
    const formData = new FormData();
    formData.append("file", file);
    return axios
      .post(`/consent_clause/upload_image_to_s3`, formData)
      .then((response) => ({ data: { link: response.data } }))
      .catch((err) => Promise.reject(err));
  };

  const handlePractitionerChange = (e) => {
    const selectedId = e.target.value;
    setSelectedPractitioner(selectedId);

    if (selectedId) {
      toast.success(
        `Saved practitioner: ${e.target.options[e.target.selectedIndex].text}`
      );
    }
  };
  React.useEffect(() => {
    if (data && data.playlists && data.playlists.length > 0) {
      const playListIndex = findIndex(data.playlists, { status: true });
      const playlist = data?.playlists?.[playListIndex]?.playlist_items || [];
      const currentVideo = playlist?.[currentVideoIndex] || null;
      setSelectedVideo(currentVideo);
    }
  }, [data, currentVideoIndex]);

  React.useEffect(() => {
    setPageLoaded(true);
  }, []);

  
  const addNewTreatment = useMutation(
  (treatmentId) => {
    return axios.put(
      `/consent_bundle/${treatmentDetails.data.id}/add_treatment/${treatmentId}`
    );
  },
  {
    onSuccess: (response) => {
      const updatedTreatments = response.data?.treatment_plan?.treatments || [];

      const selectedPlanDetails = updatedTreatments
        .map((t) => treatmentOptions.find((plan) => plan.id === t.treatment_id))
        .filter(Boolean)
        .map((plan) => ({
          ...plan,
          has_user_consent: plan.has_user_consent || false,
          has_practice_consent: plan.has_practice_consent || false,
          user_consent: plan.user_consent || [],
          practice_consent: plan.practice_consent || [],
        }));

      setSelectedPlanDetails(selectedPlanDetails);

      queryClient.invalidateQueries({ queryKey: ["treatmentDetails"] });
      queryClient.invalidateQueries({ queryKey: ["treatmentPlans"] });
    },
  }
);

  const deleteTreatment = useMutation(
  (treatmentId: number) => {
    return axios.delete(
      `/consent_bundle/${treatmentDetails.data.id}/remove_treatment/${treatmentId}`
    );
  },
  {
    onSuccess: (response) => {
      const updatedTreatments = response.data?.treatment_plan?.treatments || [];

      // Optional: map with label
      const mappedTreatments = updatedTreatments.map((t) => ({
        ...t,
        label: t.description,
        has_user_consent: t.has_user_consent || false,
        has_practice_consent: t.has_practice_consent || false,
        practice_consent: t.practice_consent || [],
        user_consent: t.user_consent || [],
      }));

      setSelectedPlanDetails(mappedTreatments);

      // Optionally keep cache invalidation
      queryClient.invalidateQueries({ queryKey: ["treatmentDetails"] });
      queryClient.invalidateQueries({ queryKey: ["treatmentPlans"] });
    },
  }
);

  const refreshTreatments = useMutation(
  () => {
    return axios.patch(
      `/consent_bundle/${treatmentDetails.data.id}/refresh_treatment_items`
    );
  },
  {
    onSuccess: (response) => {
      const updatedTreatments = response.data?.treatment_plan?.treatments || [];

      const selectedPlanDetails = updatedTreatments
        .map((t) => treatmentOptions.find((plan) => plan.id === t.treatment_id))
        .filter(Boolean)
        .map((plan) => ({
          ...plan,
          has_user_consent: plan.has_user_consent || false,
          has_practice_consent: plan.has_practice_consent || false,
          user_consent: plan.user_consent || [],
          practice_consent: plan.practice_consent || [],
        }));

      setSelectedPlanDetails(selectedPlanDetails);

      queryClient.invalidateQueries({ queryKey: ["treatmentDetails"] });
      queryClient.invalidateQueries({ queryKey: ["treatmentPlans"] });
    },
  }
);


  const deleteVideo = useMutation(
    (videoId: number) => {
      return axios.put(
        `/consent_bundle/${treatmentDetails.data.id}/toggle_visibility_playlist_item/${videoId}`
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["treatmentDetails"] });
      },
    }
  );

  const deletePlaylist = useMutation(
    (id: number) => {
      return axios.put(
        `/consent_bundle/${treatmentDetails.data.id}/toggle_visibility_playlist/${id}`
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["treatmentDetails"] });
      },
    }
  );

  const sendForSigning = useMutation(
    (consentForm: any) => {
      return axios.post(
        `/consent_bundle/${treatmentDetails.data.id}/send_consent_bundle_for_signing`,
        { consentForm }
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["treatmentDetails"] });
        window.location.href = `/${consentBundleId}/thankyou`;
      },
    }
  );

  const logData = useMutation((data: any) => {
    return axios.post(`/log`, data);
  });

  const sendForSigningFunction = () => {
    const consentForm = editorInstanceRef.current.getData();
    // const markup = draftToHtml(rawContentState);
    sendForSigning.mutate(consentForm);
  };

  const refreshPricing = () => {
    setIsUpdatingPrice(true);
    setRefreshed(false);
    axios
      .patch(
        `${process.env.REACT_APP_BASE_URL}consent_bundle/${consentBundleId}/refresh_treatment_pricing`
      )
      .then(() => {
        setIsUpdatingPrice(false);
        // queryClient.invalidateQueries({ queryKey: ["treatmentDetails"] });
        toast.success("Treatment Pricing Updated");
      })
      .catch(() => {
        setIsUpdatingPrice(false);
        toast.error("Failed to update treatment pricing");
      });
  };

  
  const handleDelete = (plan) => {
    deleteTreatment.mutate(plan.id);
  };

  const handleSelectPlan = (selectedPlan) => {
  if (!selectedPlan || isEditable) return;
  addNewTreatment.mutate(selectedPlan.id);
};

  const deleteVideoFunction = (videoId) => {
    deleteVideo.mutate(videoId);
  };

  const deletePlaylistFunction = (id) => {
    deletePlaylist.mutate(id);
  };
  const [clickedVideoId, setClickedVideoId] = React.useState(null);

  const hackUpdate = (video) => {
    setClickedVideoId(video.id);
    setSelectedVideo(null);
    setTimeout(() => {
      setSelectedVideo(video);
    }, 0);
  };

  const [open, setOpen] = React.useState(false);

  const handleOpen = async () => {
    try {
      const response = await axios.get(`/consent_bundle/${consentBundleId}`);

      if (response.status === 200) {
        setFormData(response.data.fp17dc_data);
        setSelectedTeeth(response.data.fp17dc_data);
      }
      setOpen(true);
    } catch (error) {
      console.error("Error fetching consent bundle data:", error);
    }
  };

  const handleCheckboxChangetoggle = async (event) => {
    const isChecked = event.target.checked;
    setFp17dcIsChecked(isChecked);

    setFormData({ ...formData, checkbox: isChecked });

    try {
      const response = await axios.put(
        `/consent_bundle/${consentBundleId}/toggle_fp17dc_form_generation`
      );

      setShowAddButton(response.data);
      await treatmentDetails.refetch();
    } catch (error) {
      console.error("Error updating FP17DC form generation:", error);
    }
  };

  const handleSave = async () => {
    try {
      const updatedFormData = {
        ...formData,
      };

      const response = await axios.post(
        `/consent_bundle/${consentBundleId}/save_fp17dc_form_data`,
        updatedFormData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status !== 200) {
        throw new Error(`Error: ${response.statusText}`);
      }
      const result = response.data;

      toast.success("Fp17DC data saved successfully");

      if (isRequirefp17dc) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          checkbox: true,
        }));
      }

      setOpen(false);
    } catch (error) {
      console.error("Error saving form data:", error);
      toast.error(`Failed to save form data: ${error.message}`);
    }
  };

  const handleClickModalOpen = () => {
    setModalOpen(true);
  };

  const handleClose = () => {
    if (isRequirefp17dc) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        checkbox: true,
      }));
    }
    setOpen(false);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleModalConfirm = () => {
    sendForSigningFunction();
    handleClose();
  };

  useEffect(() => {
    if (isRequirefp17dc) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        checkbox: true,
      }));
    }
  }, [isRequirefp17dc]);

  const handleInputChange = (event) => {
    const { name, type, value, checked } = event.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? (checked ? "Yes" : "No") : value,
    }));
  };

  const [formData, setFormData] = React.useState({});

  const [selectedTeeth, setSelectedTeeth] = useState([]);

  const handleToothSelect = (tooth) => {
    setSelectedTeeth((prevSelectedTeeth) => {
      const newSelectedTeeth =
        prevSelectedTeeth[tooth] === "Yes"
          ? { ...prevSelectedTeeth, [tooth]: null }
          : { ...prevSelectedTeeth, [tooth]: "Yes" };

      setFormData((prevFormData) => ({
        ...prevFormData,
        [tooth]: newSelectedTeeth[tooth],
      }));

      return newSelectedTeeth;
    });
  };

  // -------------------------------------------------------

  const [checkAccessRights, setCheckAccessRights] = useState<{
    is_owner: boolean;
    can_edit: boolean;
  }>({
    is_owner: true,
    can_edit: true,
  });
  const [isEditable, setIsEditable] = useState(false);

  useEffect(() => {
    const fetchAccessRights = async () => {
      try {
        const response = await axios.get(
          `/consent_bundle/${consentBundleId}/check_access_rights`
        );
        setCheckAccessRights(response.data);
      } catch (error) {
        console.error("Failed to fetch access rights:", error);
      }
    };

    fetchAccessRights();
  }, [consentBundleId]);
  
  useEffect(() => {
    if ((activeStep === 1 || activeStep === 2) && !checkAccessRights.is_owner &&  !checkAccessRights.can_edit ) {
      setIsEditable(true);
      setIsModalOpen(true);
    } else {
      setIsModalOpen(false);
    }
  }, [activeStep, checkAccessRights]);


useEffect(() => {
  if (isConsentEditorMode && isPanelOpen) {
    setIsPanelOpen(false);
  }
}, [isConsentEditorMode]);


  const handleCloseWarrning = () => {
    setIsModalOpen(false);
  };

  const [isSignatureModalOpen, setIsSignatureModalOpen] = useState(false);

  const [modalConsentBundleId, setModalConsentBundleId] = useState(null);

  const handleSignatureModal = (consentBundleId) => {
    setIsSignatureModalOpen(true);
    setModalConsentBundleId(consentBundleId);
  };

  const handleSignatureModalClose = () => {
    setIsSignatureModalOpen(false);
  };

  const handleCheckboxChangeApplyMySignature = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const consentForm = editorInstanceRef.current.getData();
    const placeholderExists = consentForm.includes("[clinician_signature]");

    if (e.target.checked) {
      if (placeholderExists) {
        confirmAlert({
          customUI: ({ onClose }) => (
            <div
              style={{
                padding: "20px",
                background: "#f0f0f0",
                borderRadius: "10px",
                border: "2px solid red",
              }}
            >
              <h2 style={{ color: "green" }}>CONFIRMATION</h2>
              <div>ARE YOU SURE YOU WANT TO ADD YOUR SIGNATURE?</div>
              <div style={{ marginTop: "20px" }}>
                <button
                  onClick={async () => {
                    try {
                      const response = await axios.get(
                        `/practitioner/${clinicianId}/check_if_signature_exists`
                      );
                      if (response.data === true) {
                        await axios.post(
                          `/consent_bundle/${consentBundleId}/mark_as_signed_by_practitioner`,
                          null,
                          {
                            headers: {
                              Authorization:
                                axios.defaults.headers.common.Authorization,
                            },
                          }
                        );
                        console.log("Consent bundle marked as signed.");
                        setChecked(true);
                        onClose();
                        // handleSignatureModal(consentBundleId);
                      } else {
                        handleSignatureModal(consentBundleId);
                      }
                    } catch (error) {
                      console.error(
                        "Error checking signature existence:",
                        error
                      );
                    }
                  }}
                  style={{
                    marginRight: "10px",
                    padding: "10px 15px",
                    fontSize: "14px",
                    background: "#fff",
                  }}
                >
                  Yes
                </button>
                <button
                  onClick={() => {
                    setChecked(false);
                    onClose();
                  }}
                  style={{
                    padding: "10px 15px",
                    fontSize: "14px",
                    background: "#fff",
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          ),
          buttons: [],
        });
      } else {
        confirmAlert({
          customUI: ({ onClose }) => (
            <div
              style={{
                padding: "20px",
                background: "#f0f0f0",
                borderRadius: "10px",
                border: "2px solid red",
              }}
            >
              <h2 style={{ color: "red" }}>ATTENTION</h2>
              <div>
                NO PLACEHOLDER FOR SIGNATURE FOUND. PLEASE INSERT A PLACEHOLDER
                LIKE <br />
                [clinician_signature].
              </div>
              <button
                onClick={onClose}
                style={{
                  marginTop: "13px",
                  padding: "15px 23cpx",
                  fontSize: "14px",
                  background: "#fff",
                }}
              >
                OK
              </button>
            </div>
          ),
          buttons: [],
        });
      }
    } else {
      setChecked(false);
    }
  };

  const validationCheck = () => {
    const consentForm = editorInstanceRef.current.getData();
    const placeholderExists = consentForm.includes("[clinician_signature]");
    if (placeholderExists && !isChecked) {
      confirmAlert({
        customUI: ({ onClose }) => (
          <div
            style={{
              padding: "20px",
              background: "#f0f0f0",
              borderRadius: "10px",
              border: "2px solid orange",
            }}
          >
            <h2 style={{ color: "orange" }}>Warning</h2>
            <div>
              By proceeding, all Clinician signature placeholders will be
              permanently removed from this consent form. This action will
              finalize the form, and no further signatures can be added. Please
              confirm you want to continue.
            </div>
            <div style={{ marginTop: "20px" }}>
              <button
                onClick={() => {
                  setActiveStep(3);
                  logData.mutateAsync({
                    type: "info",
                    description:
                      "Click next button to move from Videos to Consent form",
                    event: "Module Access",
                    data: {
                      consent_bundle_id: consentBundleId,
                    },
                    practice_id: user?.medicube_practice_id,
                    user_id: user?.medicube_user_id,
                  });
                  onClose();
                }}
                style={{
                  marginRight: "10px",
                  padding: "10px 15px",
                  fontSize: "14px",
                  background: "#fff",
                }}
              >
                Yes
              </button>
              <button
                onClick={() => {
                  console.log("Action canceled");
                  onClose();
                }}
                style={{
                  padding: "10px 15px",
                  fontSize: "14px",
                  background: "#fff",
                }}
              >
                No
              </button>
            </div>
          </div>
        ),
        buttons: [],
      });

      return false;
    }
    return true;
  };

  const saveForClinician = async (parameter) => {
    try {
      setIsLoading(true);
      setIsError(false);
      setIsSuccess(false);

      const consentForm = editorInstanceRef.current.getData();
      const response = await axios.post(
        `/consent_bundle/${consentBundleId}/update_consent_form`,
        {
          body: consentForm,
        }
      );

      setIsSuccess(true);

      if (parameter === "true") {
        setTimeout(() => {
          setIsSuccess(true);
          window.location.href = "/dashboard";
        }, 1000);
      } else {
        setTimeout(() => setIsSuccess(false), 2000);
      }
    } catch (error) {
      console.error("Error updating the consent bundle:", error);
      setIsError(true);
      setTimeout(() => setIsError(false), 3000);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    console.log("Playlist state updated:", playlist);
  }, [playlist]);


const handleVideoEnd = () => {
    playNextVideo();
  };

  const playNextVideo = () => {
  console.log("Playing next video");
  const currentPlaylist = activePlaylists[expandedAccordion];
  if (!currentPlaylist) return;

  const lastVideoIndex = currentPlaylist.playlist_items.length - 1;
  console.log("Current video index:", currentVideoIndex);
  console.log("Last video index in current playlist:", lastVideoIndex);

  if (currentVideoIndex === lastVideoIndex) {
   
    const nextAccordionIndex = expandedAccordion + 1;
    if (nextAccordionIndex < activePlaylists.length) {
      console.log("Jumping to next accordion:", nextAccordionIndex);
      setExpandedAccordion(nextAccordionIndex);

      const nextPlaylist = activePlaylists[nextAccordionIndex];
      if (nextPlaylist?.playlist_items?.length > 0) {
        const firstVideo = nextPlaylist.playlist_items[0];
        setClickedVideoId(firstVideo.id);
        setCurrentVideoIndex(0);
        hackUpdate(firstVideo);
      }
    } else {
      console.log("Reached the end of all playlists.");
    
    }
  } else {
   
    const nextIndex = currentVideoIndex + 1;
    const nextVideo = currentPlaylist.playlist_items[nextIndex];
    if (!nextVideo) return;

    setClickedVideoId(nextVideo.id);
    setCurrentVideoIndex(nextIndex);
    hackUpdate(nextVideo);
  }
};

const [expandedAccordion, setExpandedAccordion] = useState(0); 
const handleAccordionChange = (panel: number) => (
  event: React.SyntheticEvent,
  isExpanded: boolean
) => {
  setExpandedAccordion(isExpanded ? panel : null);

  if (isExpanded) {
    const list = activePlaylists?.[panel];
    logData.mutateAsync({
      type: "info",
      description: "Expand playlist accordion",
      event: "Module Access",
      data: {
        consent_bundle_id: consentBundleId,
        playlistId: list?.id,
      },
      practice_id: user?.medicube_practice_id,
      user_id: user?.medicube_user_id,
    });
  }
};

  const handleVideoAdded = (data: any) => {
    if (data?.playlists) {
      setPlaylist([...data.playlists]); 
      setisConsentModalsaved(true);
    } else {
      console.warn("No playlists found in data:", data);
    }
  };

  const activePlaylists = isConsentModalsaved
  ? playlist
  : treatmentDetails?.data?.playlists;


  useEffect(() => {
  if (!activePlaylists || activePlaylists.length === 0) return;

  const firstPlaylist = activePlaylists[0];
  if (!firstPlaylist.playlist_items || firstPlaylist.playlist_items.length === 0) return;

  const firstVideo = firstPlaylist.playlist_items[0];

  setClickedVideoId(firstVideo.id);
  setCurrentVideoIndex(0);
  setExpandedAccordion(0);
  hackUpdate(firstVideo);
}, [activePlaylists]);

const closePlaylistModal = () => setIsPlaylistModalOpen(false);

const handleSubmit = (formData: any) => {
  console.log(formData);
  closePlaylistModal();
};
 
  // -------------------------------------------------------
  useEffect(() => {
  if (data) {
    setLoadClinicianTemplates(data.load_clinician_templates);
    setApplyConsentTemplates(data.load_clinician_templates); 
  }
}, [data]);

const fetchAvailableConsentClauses = async (id) => {
  if (!id) {
    console.warn("No consentBundleId provided");
    return;
  }
  console.log('fetchAvailableConsentClauses called with id:', id);

  try {
    const response = await axios.get(
      `/consent_bundle/${id}/get_available_consent_clauses`
    );

    const clauses = response.data;
    setAvailableConsentClauses(clauses);

    if (availableTemplateIds.length > 0) {
      const validIds = new Set(
        clauses
          .filter(clause => availableTemplateIds.includes(clause.id))
          .map(clause => clause.id)
      );
      setSelectedClauseIds(validIds);
      setCheckedClauses(validIds); 
    } else {
      setCheckedClauses(new Set()); 
    }

    setIsPanelOpen(true);
  } catch (error) {
    console.error("Error fetching consent clauses:", error);
  }
};

const saveSelectedConsentClauses = async () => {
  if (!consentBundleId) {
    console.warn("Missing consentBundleId");
    return;
  }

  try {
    const combinedClauseIds = Array.from(selectedClauseIds).map((id) =>
      String(id)
    );

    const response = await axios.put(
      `/consent_bundle/${consentBundleId}/update_consent_form_with_selected_templates`,
      {
        block_ids: combinedClauseIds,
      }
    );

    console.log("Clauses updated successfully:", response.data);
    const bodyContent = response.data?.consent_form?.body || "";
    console.log("Updated body content:", bodyContent);

    setContent(bodyContent);
    setIsDataLoaded(true);
    editorInstanceRef.current.setData(bodyContent);
  } catch (error) {
    console.error("Error updating selected consent clauses:", error);
  }
};



useEffect(() => {
  if (openModalPlaylist) {
    getS3Data();
  }
}, [openModalPlaylist]);

const getS3Data = async () => {
  try {
    const response = await axios.get(`/playlist/global/get_global_playlist_items`);
    setS3Videos(response.data);
  } catch (error) {
    console.error("Error fetching S3 playlist items:", error);
  }
};

  return (
    <div className={styles.consentContainer}>
      <div>
        <SignatureModal
          isModalOpen={isSignatureModalOpen}
          handleModalClose={handleSignatureModalClose}
          consentBundleId={modalConsentBundleId}
          clinicanModalId={clinicianId}
        />
      </div>

      <div>
        <Dialog
          open={isModalOpen}
          onClose={handleCloseWarrning}
          sx={{
            "& .MuiDialog-paper": {
              border: "2px solid red", 
              boxShadow: "0 4px 8px rgba(255, 69, 0, 0.5)", 
            },
          }}
        >
          <DialogTitle
            sx={{
              color: "red", 
              fontWeight: "bold",
            }}
          >
            ATTENTION
          </DialogTitle>
          <DialogContent>
            <p>
              Clinician has signed the document, no further changes are allowed
              to the consent form.
            </p>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseWarrning} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <Box sx={{ width: "100%" }}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>

      {activeStep === 0 && (
        
        <div className={styles.consentSection}>
          
          <div className={styles.column}>
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px", width: "100%" }}>
            <Button
              variant="contained"
              size="small"
              color="error"
              disabled={!pageLoaded || isLoading || isEditable}
              onClick={() => setDialogOpen(true)}
              sx={{
                borderRadius: "12px",
                padding: "4px 12px",
                fontSize: "0.875rem",
              }}
              startIcon={
                isLoading ? (
                  <CircularProgress size={20} />
                ) : isError ? (
                  <ErrorIcon />
                ) : isSuccess ? (
                  <CheckCircleIcon />
                ) : (
                  <CloseIcon />
                )
              }
            >
              Exit to dashboard
            </Button>
          </div>

            <h2 className={styles.header}>Consent Details</h2>

     
            {treatmentDetails?.data?.patient && (
              <div className={styles.column}>
               
                <div className={styles.infoContainer}>
                  <p className={styles.dataItem}>
                    Name: {treatmentDetails.data.patient.title}{" "}
                    {treatmentDetails.data.patient.first_name}{" "}
                    {treatmentDetails.data.patient.last_name}
                  </p>
                  <p className={styles.subDataItem}>
                    Code: {treatmentDetails.data.code}
                  </p>
                  <p className={styles.subDataItem}>
                    Email: {treatmentDetails.data.patient.email_address}
                  </p>
                  <p className={styles.subDataItem}>
                    Mobile: {treatmentDetails.data.patient.mobile_phone}
                  </p>
                  <p className={styles.subDataItem}>
                    Address: {treatmentDetails.data.patient.address_line_1}{" "}
                    {treatmentDetails.data.patient.address_line_2}
                  </p>
                  <p className={styles.subDataItem}>
                    NHS Number: {treatmentDetails.data.patient.nhs_number}
                  </p>
                  <p className={styles.subDataItem}>
                    Version: {treatmentDetails.data.version_no}
                  </p>
                  <p className={styles.subDataItem}>
                    Mode: {treatmentDetails.data.mode === "information_leaflet"
                      ? "Information Leaflet"
                      : treatmentDetails.data.mode}
                  </p>
                </div>


              {/* Select clinician */}
              <Box style={{ marginTop: '20px' }}>
                <hr style={{ margin: '15px 0' }} />
                  <h4 style={{ marginBottom: '8px' }}>Select Clinician</h4>

                  <select
                    id="practitioner"
                    name="practitioner"
                    className={styles.dropdown}
                    onChange={handlePractitionerChange}
                    value={selectedPractitioner}
                  >
                    {practitionerList && practitionerList.length > 0 ? (
                      practitionerList.map((practitioner) => (
                        <option key={practitioner.id} value={practitioner.id}>
                          {practitioner.name}
                        </option>
                      ))
                    ) : (
                      <option value="">No practitioners available</option>
                    )}
                  </select>

                  
                  <label style={{ display: 'block', marginTop: '10px' }}>
                    <input
                      type="checkbox"
                      checked={applyConsentTemplates}
                      onChange={(e) => setApplyConsentTemplates(e.target.checked)}
                    />{' '}
                    Apply this clinician’s consent templates
                  </label>
                </Box>


              </div>
            )}
          </div>

          <div className={styles.footer}>
            <Button variant="outlined" color="secondary" csize="large" disabled>
              Back
            </Button>
            <Button
              variant="contained"
              size="large"
              onClick={async () => {
                if (!selectedPractitioner) {
                  alert("Please select a practitioner.");
                  return;
                }

                try {
                  await axios.put(
                    `/consent_bundle/${consentBundleId}/set_practitioner_for_consent_bundle`,
                    {
                      practitioner_id: selectedPractitioner,
                      load_clinician_templates: loadClinicianTemplates, 
                    }
                  );
                  handleSelectedPlanDetails();
                  setActiveStep(1);
                  await logData.mutateAsync({
                    type: "info",
                    description:
                      "Click next button to move from Consent Details to Treatment Identified",
                    event: "Module Access",
                    data: {
                      consent_bundle_id: consentBundleId,
                    },
                    practice_id: user?.medicube_practice_id,
                    user_id: user?.medicube_user_id,
                  });
                } catch (error) {
                  console.error("Error setting practitioner:", error);
                  alert("Failed to set the practitioner. Please try again.");
                }
              }}
              disabled={!pageLoaded || !selectedPractitioner}
            >
              Next
            </Button>
          </div>
        </div>
      )}

     {activeStep === 1 && (
        <div className={styles.consentSection}>
          <div className={styles.column}>
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px", width: "100%" }}>
            <Button
              variant="contained"
              size="small"
              color="error"
              disabled={!pageLoaded || isLoading || isEditable}
              onClick={() => setDialogOpen(true)}
              sx={{
                borderRadius: "12px",
                padding: "4px 12px",
                fontSize: "0.875rem",
              }}
              startIcon={
                isLoading ? (
                  <CircularProgress size={20} />
                ) : isError ? (
                  <ErrorIcon />
                ) : isSuccess ? (
                  <CheckCircleIcon />
                ) : (
                  <CloseIcon />
                )
              }
            >
              Exit to dashboard
            </Button>
          </div>
            <h2 className={styles.header}>Treatment Identified</h2>
            <div className={styles.treatmentSection}>
              <Autocomplete
                value={null}
                disableClearable
                onChange={(event: any, newValue: any) => {
                  handleSelectPlan(newValue);
                }}
                options={treatmentOptions}
                sx={{ width: 300 }}
                freeSolo
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search other treatments"
                    variant="filled"
                    disabled={isEditable} 
                    // inputProps={{
                    //   readOnly: isEditable, 
                    // }}
                  />
                )}
              />
               <>
      <Button
        variant="outlined"
        color="secondary"
        size="large"
        disabled={!pageLoaded || isEditable}
        onClick={openPopup}
      >
        Refresh Treatments
      </Button>

      <Dialog open={openTreatmentPopup} onClose={closePopup}>
        <DialogTitle style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <TreatmentIcon />
          Treatment Refresh Confirmation
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to refresh the treatments? This action will reload treatment data and may overwrite current changes.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closePopup} color="inherit">
            Cancel
          </Button>
          <Button onClick={confirmRefresh} color="warning" variant="contained">
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    </>
              {(refreshTreatments.isLoading ||
                deleteTreatment.isLoading ||
                addNewTreatment.isLoading ||
                treatmentDetails.isLoading ||
                treatmentPlans.isLoading) && <CircularProgress />}
            </div>
            
            <div className={styles.treatmentPlans}>
                {selectedPlanDetails.map((plan, index) => {
                  const showGroupIcon = plan.has_practice_consent;
                  const showUserIcon = plan.has_user_consent;

                  const iconGroup = (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                      {showGroupIcon && <GroupIcon fontSize="small" color="primary" />}
                      {showUserIcon && <PersonIcon fontSize="small" color="action" />}
                    </Box>
                  );

                  const tooltipText = [...(plan.practice_consent || []), ...(plan.user_consent || [])].join('\n');

                  return (
                    <Tooltip
                      key={index}
                      title={tooltipText ? <pre>{tooltipText}</pre> : ''}
                      arrow
                      disableHoverListener={!tooltipText} 
                    >
                      
                        <Chip
                          label={plan.label}
                          variant="outlined"
                          onDelete={() => {
                            if (!isEditable) {
                              handleDelete(plan);
                            }
                          }}
                          style={{
                            pointerEvents: isEditable ? "none" : "auto",
                            opacity: isEditable ? 0.5 : 1,
                          }}
                          avatar={
                            showGroupIcon || showUserIcon ? (
                              <Box sx={{ display: 'flex', alignItems: 'center' }}>{iconGroup}</Box>
                            ) : undefined
                          }
                        />
                    
                    </Tooltip>
                  );
                })}
              </div>
          </div>
          <div className={styles.footer}>
            <Button
              variant="outlined"
              color="secondary"
              size="large"
              onClick={() => {
                setActiveStep(0);
                logData.mutateAsync({
                  type: "info",
                  description:
                    "Click back button to move from Treatment Identified to Consent Details",
                  event: "Module Access",
                  data: {
                    consentBundleId: consentBundleId,
                  },
                  practice_id: user?.medicube_practice_id,
                  user_id: user?.medicube_user_id,
                });
              }}
            >
              Back
            </Button>
            <Button
              variant="contained"
              size="large"
              onClick={() => {
                setActiveStep(2);
                logData.mutateAsync({
                  type: "info",
                  description:
                    "Click next button to move from Treatment Identified to Videos",
                  event: "Module Access",
                  data: {
                    consentBundleId: consentBundleId,
                  },
                  practice_id: user?.medicube_practice_id,
                  user_id: user?.medicube_user_id,
                });
              }}
              disabled={!pageLoaded || isEditable}
            >
              Next
            </Button>
          </div>
        </div>
      )}

      {activeStep === 2 && (
        <div className={styles.consentSection}>

          <div style={{ display: "flex", flexDirection: "column", gap: "9px" }}>
            {/* testxt area */}
           
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
                gap: "12px",
              }}
            >
              {/* Title + Toggle */}
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <h2 className={styles.header} style={{ margin: 0 }}>
                  Consent form
                </h2>

                {/* Toggle Switch */}
            <ModeSwitchWithFeedback
                  label="Switch Editor"
                  value={isConsentEditorMode}
                  onChange={(next) => setIsConsentEditorMode(next)}
                  triggerCount={5}
                />
              </div>

              {/* Right side actions */}
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                {/* Open/Close Gallery */}
                  {!isConsentEditorMode && (
                <Button
                  variant="contained"
                  size="small"
                  disabled={isEditable}
                  onClick={() => setShowGallery(!showGallery)}
                  sx={{
                    borderRadius: "12px",
                    px: 1.5,
                    py: 0.5,
                    fontSize: "0.875rem",
                    bgcolor: "#ff9500",
                    color: "black",
                    "&:hover": { bgcolor: "#e68600" },
                  }}
                >
                  {showGallery ? "Close Gallery" : "Open Gallery"}
                </Button>)}

                {/* Add from Consent Template Library */}
             {!isConsentEditorMode && (
              <Button
                variant="contained"
                size="small"
                disabled={isEditable}
                onClick={() => fetchAvailableConsentClauses(consentBundleId)}
                sx={{
                  borderRadius: "12px",
                  px: 1.5,
                  py: 0.5,
                  fontSize: "0.875rem",
                  bgcolor: "#ff9500",
                  color: "black",
                  "&:hover": { bgcolor: "#e68600" },
                }}
              >
                Add from Consent Template Library
              </Button>
            )}


                {/* Exit to dashboard */}
                <Button
                  variant="contained"
                  size="small"
                  color="error"
                  disabled={!pageLoaded || isLoading || isEditable}
                  onClick={() => setDialogOpen(true)}
                  sx={{ borderRadius: "12px", px: 1.5, py: 0.5, fontSize: "0.875rem" }}
                  startIcon={
                    isLoading ? (
                      <CircularProgress size={20} />
                    ) : isError ? (
                      <ErrorIcon />
                    ) : isSuccess ? (
                      <CheckCircleIcon />
                    ) : (
                      <CloseIcon />
                    )
                  }
                >
                  Exit to dashboard
                </Button>
              </div>
            </div>

     <>
      {isPanelOpen && (
        <div
          onClick={() => setIsPanelOpen(true)}
          style={{
            position: "absolute",
            top: "50%",
            left: "-12px",
            width: "16px",
            height: "70px",
            background: "linear-gradient(135deg,rgb(71, 129, 255) 0%,rgb(0, 132, 255) 100%)",
            borderRadius: "8px 0 0 8px",
            cursor: "pointer",
            transform: "translateY(-50%)",
            boxShadow: "0 4px 10px rgba(0, 110, 255, 0.6)",
            userSelect: "none",
            transition: "background 0.3s ease",
            zIndex: 1100, 
          }}
          title="Open consent clauses"
          onMouseEnter={(e) =>
            (e.currentTarget.style.background =
              "linear-gradient(135deg,rgb(124, 176, 255) 0%,rgb(51, 139, 255) 100%)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.background =
              "linear-gradient(135deg,rgb(71, 129, 255) 0%,rgb(0, 132, 255) 100%)")
          }
        />
      )}
      {/* Side Panel */}
      <div
        style={{
          position: "fixed",
          top: "55%",
          right: isPanelOpen ? 0 : "-390px",
          width: "350px",
          height: "80vh",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          border: "1px solid rgba(255, 149, 0, 0.3)",
          boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
          padding: "24px 20px",
          overflowY: "auto",
          transition: "right 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
          zIndex: 1000,
          transform: "translateY(-50%)",
          borderRadius: "12px 0 0 12px",
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
          color: "#222",
        }}
      >

        {/* Panel content when open */}
        {isPanelOpen && (
          <>
            <button
              onClick={() => setIsPanelOpen(false)}
              style={{
                marginBottom: "16px",
                backgroundColor: "transparent",
                border: "none",
                fontSize: "22px",
                fontWeight: "bold",
                color: "#ff6a00",
                cursor: "pointer",
                padding: "0",
                lineHeight: "1",
                userSelect: "none",
                float: "right",
                transition: "color 0.2s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#ff8a33")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#ff6a00")}
              aria-label="Close panel"
            >
              ×
            </button>

            <h2
            style={{
              marginTop: 0,
              marginBottom: "24px",
              fontWeight: 800,
              fontSize: "1.75rem",
              letterSpacing: "0.04em",

              color: "#000", 
              borderBottom: "1px solid #eee",
              paddingBottom: "8px",
            }}
          >
            Consent Clauses
          </h2>

            {availableConsentClauses.length === 0 && (
              <p style={{ color: "#888" }}>No clauses available.</p>
            )}

            <AnimatePresence initial={false}>
              {[...availableConsentClauses]
                .sort((a, b) => {
                  const aChecked = checkedClauses.has(a.id) ? 0 : 1;
                  const bChecked = checkedClauses.has(b.id) ? 0 : 1;
                  return aChecked - bChecked;
                })
                .map(({ id, name }) => (
                  <motion.div
                    key={id}
                    layout
                    transition={{
                      layout: {
                        duration: 0.8,
                        ease: [0.22, 1, 0.36, 1],
                      },
                      opacity: {
                        duration: 0.4,
                      },
                    }}
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -30 }}
                    style={{
                      marginBottom: "18px",
                      fontSize: "1rem",
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <input
                        type="checkbox"
                        id={`clause-${id}`}
                        checked={checkedClauses.has(id)}
                        onChange={() => {
                          setCheckedClauses((prev) => {
                            const newSet = new Set(prev);
                            if (newSet.has(id)) {
                              newSet.delete(id);
                            } else {
                              newSet.add(id);
                            }
                            setSelectedClauseIds(new Set(newSet));
                            return newSet;
                          });
                        }}
                        style={{
                          width: "18px",
                          height: "18px",
                          cursor: "pointer",
                          accentColor: "#ff9500",
                        }}
                      />
                      <label
                        htmlFor={`clause-${id}`}
                        style={{
                          cursor: "pointer",
                          userSelect: "none",
                          fontWeight: 600,
                          letterSpacing: "0.02em",
                          color: "#333",
                          transition: "color 0.3s ease",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.color = "#ff9500")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.color = "#333")
                        }
                      >
                        {name}
                      </label>
                    </div>

                    <button
                      type="button"
                      onClick={() =>
                        setPreviewClause(
                          previewClause && previewClause.id === id
                            ? null
                            : availableConsentClauses.find((c) => c.id === id)
                        )
                      }
                      style={{
                        backgroundColor: "#ff9500",
                        borderRadius: "8px",
                        border: "none",
                        color: "black",
                        padding: "4px 8px",
                        cursor: "pointer",
                        fontSize: "0.85rem",
                        fontWeight: "600",
                        userSelect: "none",
                      }}
                    >
                      {previewClause && previewClause.id === id
                        ? "Close Preview"
                        : "Preview"}
                    </button>
                  </motion.div>
                ))}
            </AnimatePresence>

            {/* Save Selection flash */}
            {showSavedFlash && (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 10 }}
                style={{
                  position: "absolute",
                  bottom: "64px",
                  left: "20px",
                  backgroundColor: "#007bff",      
                  color: "white",                  
                  padding: "8px 16px",             
                  borderRadius: "10px",            
                  fontWeight: "bold",
                  fontSize: "1.1rem",              
                  boxShadow: "0 6px 12px rgba(0, 123, 255, 0.4)", 
                  userSelect: "none",
                  pointerEvents: "none",
                  zIndex: 1200,
                }}
              >
                updated successfully
            </motion.div>
          )}

            <div
              style={{
                position: "sticky",
                bottom: 0,
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                backdropFilter: "blur(10px)",
                borderTop: "1px solid rgba(255, 149, 0, 0.3)",
                paddingTop: "16px",
                paddingBottom: "8px",
                marginTop: "24px",
                zIndex: 1100,
              }}
            >
              <button
                onClick={saveSelectedConsentClauses}
                style={{
                  width: "100%",
                  backgroundColor: "#ff9500",
                  border: "none",
                  color: "white",
                  padding: "10px 16px",
                  fontSize: "1rem",
                  fontWeight: "bold",
                  borderRadius: "8px",
                  cursor: "pointer",
                  boxShadow: "0 4px 10px rgba(255, 149, 0, 0.3)",
                  transition: "background 0.3s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#ffac33")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "#ff9500")
                }
              >
                Save Selection
              </button>
            </div>
          </>
        )}
      </div>

      {/* modal */}
      {previewClause && (
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-title"
          tabIndex={-1}
          onClick={() => setPreviewClause(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1500,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              maxWidth: "1000px",
              maxHeight: "80vh",
              overflowY: "auto",
              padding: "24px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
              position: "relative",
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              color: "#222",
            }}
          >
            <button
              onClick={() => setPreviewClause(null)}
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                backgroundColor: "transparent",
                border: "none",
                fontSize: "26px",
                fontWeight: "bold",
                cursor: "pointer",
                color: "#ff6a00",
                lineHeight: "1",
              }}
              aria-label="Close preview"
            >
              ×
            </button>

            <h3
              id="modal-title"
              style={{ marginTop: 0, marginBottom: "16px" }}
            >
              {previewClause.name}
            </h3>

            <div
              dangerouslySetInnerHTML={{ __html: previewClause.body }}
              style={{ fontSize: "1rem", lineHeight: 1.5 }}
            />
          </div>
        </div>
      )}
    </>


            <div style={{ display: "flex", flex: 10 }}>

            <div style={{ flex: 4, minWidth: "500px", maxWidth: showGallery ? "70%" : "100%", transition: "max-width 0.3s", minHeight: "200px" }}>
              {!isConsentEditorMode && <textarea ref={editorRef} />}
             {isConsentEditorMode && consentBundleId && (
              <ClausesEditorPage consentBundleId={consentBundleId}
            />
            )}
            </div>



            {showGallery && (
              <div
                style={{
                  flex: 1,
                  minWidth: "650px",
                  maxWidth: "30%",
                  transition: "max-width 0.3s",
                  height: "570px",        // <-- fixed height
                  minHeight: "675px",
                  maxHeight: "675px",
                  overflow: "hidden",
                  display: "flex",        // make child stretch
                  flexDirection: "column",
                }}
              >
                <div
                  className={`${styles.imageGalleryContainer} ${styles.whiteBox}`}
                  style={{ flex: 1, minHeight: 0, overflow: "auto" }} // scroll inside if needed
                >
                  <ImageGalleryV2
                    showGallery={showGallery}
                    onClose={() => setShowGallery(false)}
                  />
                </div>
              </div>
            )}

            </div>
          </div>

          <div className={styles.row}>
            <div className={styles.column}>
              <Box
                mt={2}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                {treatmentDetails.data.mode !== 'information_leaflet' && (
                <label>
                  <input
                    type="checkbox"
                    checked={formData.checkbox}
                    onChange={handleCheckboxChangetoggle}
                  />
                  Enable FP17DC
                </label>
              )}
                &nbsp;
                {showAddButton || isRequirefp17dc ? (
                  <button
                    onClick={handleOpen}
                    
                    style={{
                      backgroundColor: "darkblue",
                      color: "white",
                      borderRadius: "20px",
                      padding: "10px 20px",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    Edit FP17DC
                  </button>
                ) : null}
                &nbsp; &nbsp; &nbsp;
                <label
                  style={{
                    color: !checkAccessRights.is_owner ? "gray" : "initial",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={applyMySignature || isChecked} // Checkbox is checked if either is true
                    onChange={handleCheckboxChangeApplyMySignature}
                    disabled={!checkAccessRights.is_owner}
                  />
                  Apply My Signature
                </label>

              </Box>

              <FormModal
                open={open}
                handleClose={handleClose}
                formData={formData}
                handleInputChange={handleInputChange}
                handleSave={handleSave}
                handleCheckboxChange={handleCheckboxChangetoggle}
                handleToothSelect={handleToothSelect}
                selectedTeeth={selectedTeeth}
              />
            </div>
          </div>

          <div className={styles.footer}>
            <Button
              variant="outlined"
              color="secondary"
              size="large"
              onClick={() => {
                saveForClinician("false");
                setActiveStep(1);
                logData.mutateAsync({
                  type: "info",
                  description:
                    "Click back button to move from Videos to Treatment Identified",
                  event: "Module Access",
                  data: {
                    consent_bundle_id: consentBundleId,
                  },
                  practice_id: user?.medicube_practice_id,
                  user_id: user?.medicube_user_id,
                });
              }}
            >
              Back
            </Button>

  {!isConsentEditorMode && (
            <div
              className={styles.buttonGroup}
              style={{ display: "flex", gap: "16px" }}
            >

             
              <LoadingButton
                loading={isLoadingViewPdf}
                variant="outlined"
                color="secondary"
                size="large"
                disabled={isEditable}
                onClick={previewPdf}
              >
                Preview
              </LoadingButton>
             
              <LoadingButton
                loading={isUpdatingPrice}
                variant="outlined"
                color="secondary"
                size="large"
                onClick={refreshPricing}
                disabled={isEditable}
              >
                Refresh Treatment Pricing
              </LoadingButton>

              <Button
                variant="outlined"
                size="large"
                color={isError ? "error" : "success"}
                disabled={!pageLoaded || isLoading ||isEditable}
                onClick={() => saveForClinician("false")}
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} />
                  ) : isSuccess ? (
                    <CheckCircleIcon />
                  ) : isError ? (
                    <ErrorIcon />
                  ) : null
                }
              >
                Save Draft
              </Button>
            </div>
 )}
            <Button
                variant="contained"
                size="large"
                onClick={async () => {
                  try {
                    await saveForClinician("false");

                    const isValid = validationCheck();

                    if (isValid) {
                      setActiveStep(3);
                      await logData.mutateAsync({
                        type: "info",
                        description: "Click next button to move from Videos to Consent form",
                        event: "Module Access",
                        data: {
                          consent_bundle_id: consentBundleId,
                        },
                        practice_id: user?.medicube_practice_id,
                        user_id: user?.medicube_user_id,
                      });
                    } else {
                      console.log("Validation failed");
                    }
                  } catch (error) {
                    console.error("Error in Next button logic:", error);
                  }
                }}
                disabled={!pageLoaded || isEditable}
                
              >
                Next
              </Button>

          </div>
        </div>
      )}

      {activeStep === 3 && (
  <div className={styles.consentSection}>
    {/* Modals (unchanged) */}
    <SelectFromStockVideoModal
      open={openModalPlaylist}
      onClose={() => setOpenModalPlaylist(false)}
      s3Videos={s3Videos}
      selectedVideos={selectedVideos}
      setSelectedVideos={setSelectedVideos}
      hoveredVideo={hoveredVideo}
      setHoveredVideo={setHoveredVideo}
      anchorEl={anchorEl}
      setAnchorEl={setAnchorEl}
      consentBundleId={consentBundleId}
      onSuccess={() => {
        treatmentDetails.refetch();
      }}
    />

    <PlaylistModal open={isPlaylistModalOpen} onClose={closePlaylistModal} onSubmit={handleSubmit} />

    <ConsentBundelPlaylistModel
      open={openConsentModal}
      onClose={() => setOpenConsentModal(false)}
      listId={selectedListId}
      consentBundleId={consentBundleId}
      onSuccess={() => {
        treatmentDetails.refetch();
      }}
    />

    {/* Content */}
    {treatmentDetails?.data?.playlists?.length > 0 ? (
      <Grid container spacing={2}>
        {/* Left: playlists */}
       

        {/* Right: player */}
        <Grid item xs={12} md={7} lg={8}>
          <Card
            elevation={0}
            sx={{
              borderRadius: 3,
              border: "1px solid",
              borderColor: "divider",
              overflow: "hidden",
            }}
          >
            <CardHeader
              titleTypographyProps={{ fontWeight: 700 }}
              title={selectedVideo ? selectedVideo.title : "Preview"}
              subheader={selectedVideo ? "Selected video" : "No video selected"}
              sx={{ pb: 0 }}
            />
            <Divider />
            <CardContent sx={{ p: 0 }}>
              {selectedVideo ? (
                <Box sx={{ position: "relative", width: "100%", pt: "56.25%" }}>
                  <Box sx={{ position: "absolute", inset: 0 }}>
                    <ReactPlayer
                      url={selectedVideo.url}
                      playing={false}
                      controls
                      width="100%"
                      height="100%"
                      onEnded={handleVideoEnd}
                    />
                  </Box>
                </Box>
              ) : (
                <Box
                  sx={{
                    py: 8,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "text.secondary",
                  }}
                >
                  No active videos to display
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
         <Grid item xs={12} md={5} lg={4}>
          <Card
            elevation={0}
            sx={{
              borderRadius: 3,
              border: "1px solid",
              borderColor: "divider",
              overflow: "hidden",
            }}
          >
            <CardHeader
              titleTypographyProps={{ fontWeight: 700 }}
              title="Playlists"
              subheader={`${activePlaylists?.length || 0} list${(activePlaylists?.length || 0) === 1 ? "" : "s"}`}
              sx={{ pb: 0.5 }}
              action={
                <Stack direction="row" spacing={1}>
                  <Button
                    variant="contained"
                    size="small"
                    color="info"
                    disabled={!pageLoaded || isLoading || isEditable}
                    onClick={() => {
                      setSelectedListId(null);
                      setOpenConsentModal(true);
                    }}
                    sx={{
                      borderRadius: "12px",
                      px: 1.5,
                      py: 0.75,
                      fontSize: "0.875rem",
                      textTransform: "none",
                    }}
                    startIcon={<AddIcon />}
                  >
                    Add from YouTube
                  </Button>

                  <Button
                    variant="outlined"
                    size="small"
                    color="primary"
                    disabled={!pageLoaded || isLoading || isEditable}
                    onClick={() => setOpenModalPlaylist(true)}
                    sx={{
                      borderRadius: "12px",
                      px: 1.5,
                      py: 0.75,
                      fontSize: "0.875rem",
                      textTransform: "none",
                    }}
                    startIcon={<AddIcon />}
                  >
                    Add stock video
                  </Button>
                </Stack>
              }
            />
            <Divider />
            <CardContent sx={{ pt: 1.5 }}>
              <div className="accordion-container">
                {activePlaylists?.map((list, index) => (
                  <Accordion
                    key={list.id || index}
                    disabled={deletePlaylist.isLoading}
                    expanded={expandedAccordion === index}
                    onChange={handleAccordionChange(index)}
                    sx={{
                      "&:before": { display: "none" },
                      border: "1px solid",
                      borderColor: expandedAccordion === index ? "primary.light" : "divider",
                      borderRadius: 2,
                      mb: 1,
                    }}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Stack direction="row" alignItems="center" spacing={1} sx={{ width: "100%" }}>
                        <Typography sx={{ flexGrow: 1, fontWeight: 600 }}>{list?.title}</Typography>
                        <Chip
                          size="small"
                          label={`${list?.playlist_items?.length || 0}`}
                          sx={{ fontWeight: 700 }}
                          color="default"
                          variant="outlined"
                        />
                        <Box sx={{ display: "flex", gap: 1 }}>
                          {list.status ? (
                            <VisibilityIcon
                              fontSize="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                deletePlaylistFunction(list.id);
                              }}
                              sx={{ cursor: "pointer" }}
                            />
                          ) : (
                            <VisibilityOffIcon
                              fontSize="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                deletePlaylistFunction(list.id);
                              }}
                              sx={{ cursor: "pointer" }}
                            />
                          )}
                        </Box>
                      </Stack>
                    </AccordionSummary>

                    <AccordionDetails sx={{ pt: 0 }}>
                      <Box
                        className={styles.playList}
                        sx={{
                          maxHeight: list.playlist_items?.length > 4 ? 320 : "auto",
                          overflowY: list.playlist_items?.length > 4 ? "auto" : "visible",
                          pr: 0.5,
                        }}
                      >
                        <Stack direction="column" spacing={1.2}>
                          {list?.playlist_items?.map((video, vidIndex) => (
                            <Chip
                              key={video.id || vidIndex}
                              className={cx(styles.description, {
                                [styles.active]:
                                  (vidIndex === currentVideoIndex && !clickedVideoId) ||
                                  video.id === clickedVideoId,
                                [styles.selectedVideo]: video.id === clickedVideoId,
                              })}
                              label={video.title}
                              avatar={
                                <Avatar
                                  src={video.thumbnail}
                                  alt={video.title}
                                  sx={{ width: 40, height: 40, borderRadius: 1 }}
                                />
                              }
                              variant={video.status ? "outlined" : "filled"}
                              sx={{
                                height: 48,
                                fontSize: "0.95rem",
                                px: 1.5,
                                "& .MuiChip-label": {
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: 220,
                                },
                              }}
                              onDelete={() => deleteVideoFunction(video.id)}
                              deleteIcon={video.status ? <VisibilityIcon /> : <VisibilityOffIcon />}
                              onClick={() => {
                                hackUpdate(video);
                                logData.mutateAsync({
                                  type: "info",
                                  description: "Click video thumbnail",
                                  event: "Module Access",
                                  data: { consent_bundle_id: consentBundleId, video: video.title },
                                  practice_id: user?.medicube_practice_id,
                                  user_id: user?.medicube_user_id,
                                });
                              }}
                              disabled={deleteVideo.isLoading}
                            />
                          ))}
                        </Stack>
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </div>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    ) : (
      /* Empty state (no playlists/videos) */
      <Card
        elevation={0}
        sx={{
          borderRadius: 3,
          border: "1px dashed",
          borderColor: "divider",
          p: 4,
          textAlign: "center",
          bgcolor: "background.default",
        }}
      >
        <Stack spacing={2} alignItems="center">
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              display: "grid",
              placeItems: "center",
              bgcolor: "grey.100",
              color: "grey.700",
            }}
          >
            <VideoLibraryIcon />
          </Box>

          <Typography variant="h6" fontWeight={800}>
            No videos yet
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 480 }}>
            Add educational or consent-related videos for the patient. You can choose from YouTube or select stock videos.
          </Typography>

          <Stack direction="row" spacing={1.5} flexWrap="wrap" justifyContent="center" sx={{ pt: 1 }}>
            <Button
              variant="contained"
              size="small"
              color="info"
              disabled={!pageLoaded || isLoading || isEditable}
              onClick={() => {
                setSelectedListId(null);
                setOpenConsentModal(true);
              }}
              sx={{
                borderRadius: "12px",
                px: 1.5,
                py: 0.75,
                fontSize: "0.875rem",
                textTransform: "none",
              }}
              startIcon={<AddIcon />}
            >
              Add video from YouTube
            </Button>

            <Button
              variant="outlined"
              size="small"
              color="primary"
              disabled={!pageLoaded || isLoading || isEditable}
              onClick={() => setOpenModalPlaylist(true)}
              sx={{
                borderRadius: "12px",
                px: 1.5,
                py: 0.75,
                fontSize: "0.875rem",
                textTransform: "none",
              }}
              startIcon={<AddIcon />}
            >
              Add stock video
            </Button>
          </Stack>

          <Typography variant="caption" color="text.secondary">
            You can still proceed by clicking <strong>Send</strong> below.
          </Typography>
        </Stack>
      </Card>
    )}

    {/* Footer Actions (unchanged) */}
    <Box className={styles.footer} sx={{ mt: 3 }}>
      <Button
        variant="outlined"
        color="secondary"
        size="large"
        onClick={() => {
          setActiveStep(2);
          logData.mutateAsync({
            type: "info",
            description: "Click back button to move from Consent form to Videos",
            event: "Module Access",
            data: { consent_bundle_id: consentBundleId },
            practice_id: user?.medicube_practice_id,
            user_id: user?.medicube_user_id,
          });
        }}
        disabled={sendForSigning.isLoading}
      >
        Back
      </Button>

      {treatmentDetails.data.version_no > 1 ? (
        <LoadingButton
          loading={sendForSigning.isLoading}
          variant="contained"
          color="success"
          size="large"
          onClick={handleClickModalOpen}
          disabled={sendForSigning.isLoading}
        >
          Send
        </LoadingButton>
      ) : (
        <LoadingButton
          loading={sendForSigning.isLoading}
          variant="contained"
          color="success"
          size="large"
          onClick={sendForSigningFunction}
          disabled={sendForSigning.isLoading}
        >
          Send
        </LoadingButton>
      )}
    </Box>

    {/* Confirm dialog (unchanged) */}
    <Dialog open={modalOpen} onClose={handleModalClose}>
      <DialogTitle>Warning</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Your patient will lose access to the previous version. Would you like to continue?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleModalClose}>No</Button>
        <Button onClick={handleModalConfirm} autoFocus>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  </div>
)}


      {pdfUrl && isOpenPdfViewer && (
        <PdfViewer
          isOpen={isOpenPdfViewer}
          close={() => setIsOpenPdfViewer(false)}
          pdfUrl={pdfUrl}
        />
      )}

      <Dialog open={isDialogOpen} onClose={() => setDialogOpen(false)}>
          <DialogTitle>
            {activeStep === 0
              ? "Confirm Exit"
              : activeStep === 1 || activeStep === 3
              ? "Exit Confirmation"
              : "Save Draft"}
          </DialogTitle>
          <DialogContent>
            {activeStep === 0
              ? "Are you sure you want to exit ?"
              : activeStep === 1 || activeStep === 3
              ? "Are you sure you want to exit? Your selected treatments are automatically saved."
              : "Do you want to save the draft before exiting?"}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setDialogOpen(false);
              }}
              color="secondary"
            >
              Cancel
            </Button>

          
            {activeStep === 0 || activeStep === 1 || activeStep === 3 ? (
          
              <Button
                onClick={() => {
                  setDialogOpen(false);
                  window.location.href = "/dashboard"; 
                }}
                color="error"
                variant="contained"
              >
                Exit
              </Button>
            ) : (
              
              <>
                <Button
                  onClick={() => {
                    saveForClinician("true"); 
                    setDialogOpen(false);
                    router.push("/dashboard"); 
                  }}
                  color="primary"
                  variant="contained"
                >
                  Save & Exit
                </Button>
                <Button
                  onClick={() => {
                    setDialogOpen(false);
                    window.location.href = "/dashboard"; 
                  }}
                  color="error"
                  variant="contained"
                >
                  Exit Without Saving
                </Button>
              </>
            )}
          </DialogActions>
        </Dialog>
    </div>
  );
}
